module.exports = __webpack_public_path__ + "static/media/finance-feature-tile-icon-02..8b4a467c.svg";